import * as styles from './sca-badge.css.ts'

export const ScaBadge: React.FC = () => {
  return <span className={styles.scaBadge}>SCA</span>
}
